<template>
  <v-expansion-panels v-model="displayed">
    <v-expansion-panel title="Booking Numbers">
      <v-expansion-panel-text>
        <v-list density="compact">
          <v-list-item
            v-for="(count, jobId) in appointmentStore.jobCount"
            :key="jobId"
            :value="jobId"
            class="job-count-list-item"
          >
            <template v-slot:prepend>
              <count-badge :color="serviceColors[jobId]">{{
                count
              }}</count-badge>
            </template>
            <v-list-item-title class="text-body-2 pl-2">{{
              getDescriptionFromId(jobId)
            }}</v-list-item-title>
          </v-list-item>
          <hr />
          <v-list-item>
            <template #prepend>
              <count-badge>{{ deleted }}</count-badge>
            </template>
            <v-list-item-title>Deleted Jobs</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script setup>
import { useAppointmentStore } from "../../../stores/appointmentsStore";
import { useEventStore } from "../../../stores/EventStore";

import { ref, computed } from "vue";
import CountBadge from "./countBadge.vue";
import { serviceColors, servicesList } from "../../../libs/options";

function getDescriptionFromId(id) {
  return servicesList.find((obj) => obj.id == id).description;
}
const appointmentStore = useAppointmentStore();
const displayed = ref([0]);
const eventStore = useEventStore();
const deleted = computed(() => eventStore.getRemovedEventsCount);
</script>

<style>
.v-expansion-panel-text__wrapper {
  padding: 8px 4px 16px;
}
.v-list-item {
  padding-inline-start: 4px;
  padding-inline-end: 4px;
}

.v-expansion-panel-title {
  padding: 12px 24px;
}

.v-expansion-panel--active > .v-expansion-panel-title {
  min-height: 20px;
}
.job-count-list-item {
  cursor: auto;
}
</style>
